module.exports = __webpack_public_path__ + "img/hot-sale.c33857b5.png";